export function parseMessage<T>(message: Uint8Array) {
  const payload = new TextDecoder().decode(message);
  const data: T = JSON.parse(payload);

  return data;
}
